<template>
  <v-btn
    @click="sampleDownloadFileClick()"
    text
    small
    class="text-none primaryColor font-weight-medium"
    :loading="fileDownloadLoading"
    >
    <v-icon small >mdi-download</v-icon> Download Sample Template for {{entityName}}
    </v-btn>

</template>

<script>
export default {
  name: 'AdminSampleDownloadButton',
  data: () => ({
    fileDownloadLoading: false
  }),
  props: {
    fileName: {
      Type: String
    },
    entityName: {
      Type: String
    }
  },
  computed: {
  },
  methods: {
    sampleDownloadFileClick () {
      let fileName = this.fileName
      if (fileName !== '' && fileName !== undefined && fileName !== null) {
        this.fileDownloadLoading = true
        new Promise((resolve, reject) => {
          this.$store.dispatch('SampleDownloadModule/getFile', {
            resolve,
            reject,
            fileName
          })
        })
          .then(responseData => {
            var blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), responseData], { type: 'text/plain;charset=utf-8' })
            if (navigator.msSaveBlob) { // IE 10+
              navigator.msSaveBlob(blob, 'sample_file.csv')
            } else {
              var fileURL = window.URL.createObjectURL(blob)
              var fileLink = document.createElement('a')
              fileLink.href = fileURL
              fileLink.setAttribute('download', 'sample_file.csv')
              document.body.appendChild(fileLink)
              fileLink.click()
              fileLink.remove()
            }
          })
          .catch(response => {
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText('Something went wrong! unable to download sample file.')
            this.$globalStates.notification.init_notifications = true
          })
          .finally(() => { this.fileDownloadLoading = false })
      }
    }
  }
}
</script>
